import type { DataTableColumn } from '@odo/shared-ui';
import { StatusBadge, type Tone } from '../StatusBadge';
import type { VendorListItem } from '../../../services/vendors';
import { OrderMethodsCell } from './OrderMethodsCell';

export type VendorsSortBy = 'name' | 'methods';

const VENDOR_STATE_TONES: Record<string, Tone> = {
    active: { bg: 'bg-emerald-600' },
    retired: { bg: 'bg-gray-400', strike: true }
};

export function buildVendorColumns(): DataTableColumn<VendorListItem, VendorsSortBy>[] {
    return [
        {
            key: 'name',
            label: 'Vendor',
            width: '26%',
            sortable: true,
            sortKey: 'name',
            truncate: true,
            cellClassName: 'pl-6 pr-3 text-sm',
            headerClassName: 'whitespace-nowrap px-3 pl-6',
            getTitle: (vendor) => vendor.name,
            render: (vendor) => (
                <span className="block font-medium text-gray-800 truncate">{vendor.name}</span>
            )
        },
        {
            key: 'id',
            label: 'Slug',
            width: '18%',
            truncate: true,
            cellClassName: 'px-3',
            headerClassName: 'whitespace-nowrap px-3',
            getTitle: (vendor) => vendor.id,
            // The slug is what appears in dispatch logs and on PO rows.
            render: (vendor) => (
                <span className="font-mono text-[12px] text-gray-500">{vendor.id}</span>
            )
        },
        {
            key: 'methods',
            label: 'Ordering methods',
            width: '24%',
            sortable: true,
            sortKey: 'methods',
            cellClassName: 'px-3',
            headerClassName: 'whitespace-nowrap px-3',
            render: (vendor) => <OrderMethodsCell vendor={vendor} />
        },
        {
            key: 'products',
            label: 'Products',
            width: '11%',
            align: 'right',
            cellClassName: 'px-3 text-sm text-gray-700 tabular-nums',
            headerClassName: 'whitespace-nowrap px-3',
            render: (vendor) => vendor.references.linkedProducts
        },
        {
            key: 'livePos',
            label: 'Live POs',
            width: '11%',
            align: 'right',
            cellClassName: 'px-3 text-sm text-gray-700 tabular-nums',
            headerClassName: 'whitespace-nowrap px-3',
            render: (vendor) => vendor.references.livePurchaseOrders
        },
        {
            key: 'state',
            label: 'State',
            width: '10%',
            cellClassName: 'px-3',
            headerClassName: 'whitespace-nowrap px-3',
            render: (vendor) => (
                <StatusBadge
                    status={vendor.isActive ? 'active' : 'retired'}
                    toneOverride={VENDOR_STATE_TONES}
                />
            )
        }
    ];
}
